import Vue from 'vue';
import Main from "./index.vue";
var instance;
var seed = 1;
var LoginOutConstructor = Vue.extend(Main);

var LoginOut = function LoginOut(str) {
  var id = 'loginout_' + seed++;
  instance = new LoginOutConstructor({
    propsData: {
      loginOutTip: str
    }
  });
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  return instance.vm;
};

export default LoginOut;